// extracted by mini-css-extract-plugin
export default {"button":"ReplayRemaining_button__pJewx"};